var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 11.9997V27.9997H1.33325V11.9997H6.66659ZM11.9999 27.9997C11.2927 27.9997 10.6144 27.7187 10.1143 27.2186C9.6142 26.7185 9.33325 26.0403 9.33325 25.333V11.9997C9.33325 11.2663 9.62659 10.5997 10.1199 10.1197L18.8933 1.33301L20.3066 2.74634C20.6666 3.10634 20.8933 3.59967 20.8933 4.14634L20.8533 4.57301L19.5866 10.6663H27.9999C28.7072 10.6663 29.3854 10.9473 29.8855 11.4474C30.3856 11.9475 30.6666 12.6258 30.6666 13.333V15.9997C30.6666 16.3463 30.5999 16.6663 30.4799 16.973L26.4533 26.373C26.0533 27.333 25.1066 27.9997 23.9999 27.9997H11.9999ZM11.9999 25.333H24.0399L27.9999 15.9997V13.333H16.2799L17.7866 6.23967L11.9999 12.0397V25.333Z",
    fill: "#153C58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.921f97cded200e5047f8801423dbb126.svg";
export { ForwardRef as ReactComponent };